import { fabric } from "fabric"
const defaultGrid = {
    size: 60,
    enabled: false,
    color: "#e2e2e2",
    name: "bgGrid",
    snap: false,
  }

export function drawVerticalLineIcon(
    ctx,
    left,
    top,
    styleOverride,
    fabricObject
  ) {
    const size = this.cornerSize
    ctx.save()
    ctx.translate(left, top)
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle))
    ctx.beginPath()
    ctx.lineCap = "round"
    ctx.lineWidth = 3
    ctx.shadowBlur = 2
    ctx.shadowColor = "black"
    ctx.moveTo(-0.5, -size / 4)
    ctx.lineTo(-0.5, -size / 4 + size / 2)
    ctx.strokeStyle = "#ffffff"
    ctx.stroke()
    ctx.restore()
  }
  
  export function drawHorizontalLineIcon(
    ctx,
    left,
    top,
    styleOverride,
    fabricObject
  ) {
    const size = this.cornerSize
    ctx.save()
    ctx.translate(left, top)
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle))
    ctx.beginPath()
    ctx.lineCap = "round"
    ctx.lineWidth = 3
    ctx.shadowBlur = 2
    ctx.shadowColor = "black"
    ctx.moveTo(-size / 4, -0.5)
    ctx.lineTo(-size / 4 + size / 2, -0.5)
    ctx.strokeStyle = "#ffffff"
    ctx.stroke()
    ctx.restore()
  }
  

  export function SendToBack(canvas){
    let currentObj = canvas.getActiveObject();
    if (currentObj != undefined) {
      canvas.sendToBack(currentObj);


      canvas.renderAll();
    }
  }
  export function  bringFronts(canvas){
    

    let currentObj = canvas.getActiveObject();
    if (currentObj != undefined) {

      canvas.bringToFront(currentObj);


      canvas.renderAll();
    }
  }
  export function  SendBackward(canvas){

    let currentObj = canvas.getActiveObject();
    if (currentObj != undefined) {
      canvas.sendBackwards(currentObj);



      canvas.renderAll();
    }
  }

  export function  BrignForward(canvas){
    let currentObj = canvas.getActiveObject();
    if (currentObj != undefined) {

      canvas.bringForward(currentObj);


      canvas.renderAll();
    }
  }

  export function LockObj(canvas) {

    let currentObj = canvas.getActiveObject();
    currentObj.set({
        lockMovementX:true,
        lockMovementY:true,
        lockScalingX :true,
        lockScalingY:true, 
        hasControls: false,
        isLockedobj:true,
        editable: false,

    });
    canvas.discardActiveObject();

    canvas.renderAll();

  }

  export function UnLockObj(canvas) {

    let currentObj = canvas.getActiveObject();
    currentObj.set({
        lockMovementX:false,
        lockMovementY:false,
        lockScalingX :false,
        lockScalingY:false, 
        hasControls: true,
        isLockedobj:false,
        editable: true,

    });
    canvas.discardActiveObject();

    canvas.renderAll();

  }

  export function cloneObject(canvas) {
    let currentObj = canvas.getActiveObject();

    currentObj.clone(function(clone) {
        canvas.add(clone.set({
            left: currentObj.left + 10, 
            top: currentObj.top + 10
        }));
    });
    canvas.renderAll();
}


export function drawGrid(canvas){
    

    if (canvas){
      const gridGroupOpts = {
        opacity: 0.6,
        selectable: false,
        hoverCursor: "default",
        originX: "center",
        originY: "center",
      }
        const gridGroup = new fabric.Group(null, gridGroupOpts)
        // draw vertical lines
        for (var i = 0; i < canvas.width / defaultGrid.size; i++) {
          gridGroup.addWithUpdate(
            new fabric.Line(
              [i * defaultGrid.size, 0, i * defaultGrid.size, canvas.height],
              {
                stroke: "#ccc",
                selectable: false,
              }
            )
          )
        }

        // draw horizontal lines
        for (var j = 0; j < canvas.height / defaultGrid.size; j++) {
          gridGroup.addWithUpdate(
            new fabric.Line([0, j * defaultGrid.size, canvas.width, j * defaultGrid.size], {
              stroke: "#ccc",
              selectable: false,
            })
          )
        }

        gridGroup.name = defaultGrid.name
        gridGroup.id = Math.random() + ""
        // searching into canvas to avoid duplicates grids
        const currentGrid = canvas
          .getObjects()
          .find((obj) => obj.name == defaultGrid.name)
        // if not found, it is needed to add grids to that canvas
        if (!currentGrid){
          canvas.add(gridGroup)
          canvas.moveTo(gridGroup, 0)
        }

    }
}


export function  removeGrid(canvas){ 

    if (canvas){
        const [currentGrid] = canvas
          .getObjects()
          .filter((obj) => obj.name === defaultGrid.name)
        if (currentGrid) {
          canvas.remove(currentGrid)
        }
    }
}





export function drawLineOnSelections(canvas){
    var line, isDown,mode;
    mode = "draw"
    canvas.on('mouse:down', function(o){
        isDown = true;
        var pointer = canvas.getPointer(o.e);
        var points = [ pointer.x, pointer.y, pointer.x, pointer.y ];
         
        if(mode=="draw"){
          line = new fabric.Line(points, {
          strokeWidth: 5,
          fill: 'red',
          stroke: 'red',
          originX: 'center',
          originY: 'center',
      
        });
        canvas.add(line);
    }
      });
       
      canvas.on('mouse:move', function(o){
        if (!isDown) return;
        var pointer = canvas.getPointer(o.e);
        
        if(mode=="draw"){
        line.set({ x2: pointer.x, y2: pointer.y });
        canvas.renderAll(); }
      });

      canvas.on('mouse:up', function(){
        isDown = false;
        line.setCoords();

        mode="select";   
        canvas.selection=true;
        canvas.renderAll();
      });
      
}

export function addBorderOnObjectHover(canvas){

  canvas.on('mouse:over', function(o){
    
    var selectedObj = o.target;
    if(selectedObj){
      

      selectedObj._renderControls(canvas.contextTop, {
        hasControls: false
      })
    }
  });

  canvas.on('mouse:down', function(){
    canvas.clearContext(canvas.contextTop);
  });
  canvas.on('mouse:out', function(o){
    var selectedObj = o.target;
    if(selectedObj){

      canvas.clearContext(canvas.contextTop);
    }
  });
}




export function initAligningGuidelines(canvas) {

    let ctx = canvas.getSelectionContext(),
        aligningLineOffset = 5,
        aligningLineMargin = 4,
        aligningLineWidth = 1,
        aligningLineColor = 'red',
        viewportTransform,
        verticalLines = [],
        horizontalLines = [];
  
    function drawVerticalLine(coords) {
      drawLine(
        coords.x + 0.5, coords.y1 > coords.y2 ? coords.y2 : coords.y1,
        coords.x + 0.5, coords.y2 > coords.y1 ? coords.y2 : coords.y1
      )
    }
  
    function drawHorizontalLine(coords) {
      drawLine(
        coords.x1 > coords.x2 ? coords.x2 : coords.x1, coords.y + 0.5,
        coords.x2 > coords.x1 ? coords.x2 : coords.x1, coords.y + 0.5
      )
    }
  
    function drawLine(x1, y1, x2, y2) {
      var originXY = fabric.util.transformPoint(new fabric.Point(x1, y1), canvas.viewportTransform),
                  dimmensions = fabric.util.transformPoint(new fabric.Point(x2, y2),canvas.viewportTransform);
      ctx.save()
      ctx.lineWidth = aligningLineWidth
      ctx.strokeStyle = aligningLineColor
      ctx.beginPath()
      //console.log("x1 :" + x1)
      //console.log("viewportTransform[4] :" + viewportTransform[4])
      //console.log("zoom :" + zoom)
      ctx.moveTo(
        ( (originXY.x ) ),
        ( (originXY.y ) )
      )
      //console.log("-------")
      //console.log("x1 :" + x1)
      //console.log("viewportTransform[4] :" + viewportTransform[4])
      //console.log("zoom :" + zoom)
      //console.log("x :" + (x1 + canvas.viewportTransform[4]) * zoom)
      
      ctx.lineTo(
        ( (dimmensions.x ) ),
        ( (dimmensions.y ) )
      )
      ctx.stroke()
      ctx.restore()
    }
  
    function isInRange(value1, value2) {
      value1 = Math.round(value1)
      value2 = Math.round(value2)
      for (var i = value1 - aligningLineMargin, len = value1 + aligningLineMargin; i <= len; i++) {
        if (i === value2) {
          return true
        }
      }
      return false;
    }
  
   
    
  
    canvas.on('mouse:down', function () {
      verticalLines.length = horizontalLines.length = 0
      viewportTransform = canvas.viewportTransform
    })
  
    canvas.on('object:moving', (e) => {
      
      verticalLines.length = horizontalLines.length = 0
  
      let activeObject = e.target,
          canvasObjects = canvas.getObjects(),
          activeObjectCenter = activeObject.getCenterPoint(),
          activeObjectLeft = activeObjectCenter.x,
          activeObjectTop = activeObjectCenter.y,
          activeObjectBoundingRect = activeObject.getBoundingRect(),
          activeObjectHeight = activeObjectBoundingRect.height / viewportTransform[3],
          activeObjectWidth = activeObjectBoundingRect.width / viewportTransform[0],
          horizontalInTheRange = false,
          verticalInTheRange = false,
          transform = canvas._currentTransform;
      
      //console.log("|||||||||")
      //console.log("active acoords is: " + JSON.stringify(activeObject.aCoords, null, 4))
      //console.log("active acoords is: " + JSON.stringify(activeObject.oCoords, null, 4))
      //console.log("active left offset is: " + JSON.stringify(activeObject.aCoords, null, 4))
      //containerWidth = canvasContainer.offsetWidth
      //containerHeight = canvasContainer.offsetHeight
      //console.log("active left from container is: " + (containerWidth - this.outer.width) / 2 + activeObject.aCoords.tl.x )
  
      if (!transform) return;
  
      // It should be trivial to DRY this up by encapsulating (repeating) creation of x1, x2, y1, and y2 into functions,
      // but we're not doing it here for perf. reasons -- as this a function that's invoked on every mouse move
  
      for (let i = canvasObjects.length; i--; ) {
  
        if (canvasObjects[i] === activeObject) continue
  
        let objectCenter = canvasObjects[i].getCenterPoint(),
            objectLeft = objectCenter.x,
            objectTop = objectCenter.y,
            objectBoundingRect = canvasObjects[i].getBoundingRect(),
            objectHeight = objectBoundingRect.height / viewportTransform[3],
            objectWidth = objectBoundingRect.width / viewportTransform[0]
  
        // snap by the horizontal center line
        if (isInRange(objectLeft, activeObjectLeft)) {
          verticalInTheRange = true
          verticalLines.push({
            x: objectLeft,
            y1: (objectTop < activeObjectTop)
              ? (objectTop - objectHeight / 2 - aligningLineOffset)
              : (objectTop + objectHeight / 2 + aligningLineOffset),
            y2: (activeObjectTop > objectTop)
              ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
              : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
          })
          activeObject.setPositionByOrigin(new fabric.Point(objectLeft, activeObjectTop), 'center', 'center');
        }
  
        // snap by the left edge
        if (isInRange(objectLeft - objectWidth / 2, activeObjectLeft - activeObjectWidth / 2)) {
          verticalInTheRange = true
          verticalLines.push({
            x: objectLeft - objectWidth / 2,
            y1: (objectTop < activeObjectTop)
              ? (objectTop - objectHeight / 2 - aligningLineOffset)
              : (objectTop + objectHeight / 2 + aligningLineOffset),
            y2: (activeObjectTop > objectTop)
              ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
              : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
          })
          activeObject.setPositionByOrigin(new fabric.Point(objectLeft - objectWidth / 2 + activeObjectWidth / 2, activeObjectTop), 'center', 'center')
        }
  
        // snap by the right edge
        if (isInRange(objectLeft + objectWidth / 2, activeObjectLeft + activeObjectWidth / 2)) {
          verticalInTheRange = true
          verticalLines.push({
            x: objectLeft + objectWidth / 2,
            y1: (objectTop < activeObjectTop)
              ? (objectTop - objectHeight / 2 - aligningLineOffset)
              : (objectTop + objectHeight / 2 + aligningLineOffset),
            y2: (activeObjectTop > objectTop)
              ? (activeObjectTop + activeObjectHeight / 2 + aligningLineOffset)
              : (activeObjectTop - activeObjectHeight / 2 - aligningLineOffset)
          })
          activeObject.setPositionByOrigin(new fabric.Point(objectLeft + objectWidth / 2 - activeObjectWidth / 2, activeObjectTop), 'center', 'center')
        }
  
        // snap by the vertical center line
        if (isInRange(objectTop, activeObjectTop)) {
          horizontalInTheRange = true;
          horizontalLines.push({
            y: objectTop,
            x1: (objectLeft < activeObjectLeft)
              ? (objectLeft - objectWidth / 2 - aligningLineOffset)
              : (objectLeft + objectWidth / 2 + aligningLineOffset),
            x2: (activeObjectLeft > objectLeft)
              ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
              : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
          })
          activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop), 'center', 'center')
        }
  
        // snap by the top edge
        if (isInRange(objectTop - objectHeight / 2, activeObjectTop - activeObjectHeight / 2)) {
          horizontalInTheRange = true
          horizontalLines.push({
            y: objectTop - objectHeight / 2,
            x1: (objectLeft < activeObjectLeft)
              ? (objectLeft - objectWidth / 2 - aligningLineOffset)
              : (objectLeft + objectWidth / 2 + aligningLineOffset),
            x2: (activeObjectLeft > objectLeft)
              ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
              : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
          })
          activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop - objectHeight / 2 + activeObjectHeight / 2), 'center', 'center');
        }
  
        // snap by the bottom edge
        if (isInRange(objectTop + objectHeight / 2, activeObjectTop + activeObjectHeight / 2)) {
          horizontalInTheRange = true
          horizontalLines.push({
            y: objectTop + objectHeight / 2,
            x1: (objectLeft < activeObjectLeft)
              ? (objectLeft - objectWidth / 2 - aligningLineOffset)
              : (objectLeft + objectWidth / 2 + aligningLineOffset),
            x2: (activeObjectLeft > objectLeft)
              ? (activeObjectLeft + activeObjectWidth / 2 + aligningLineOffset)
              : (activeObjectLeft - activeObjectWidth / 2 - aligningLineOffset)
          })
          activeObject.setPositionByOrigin(new fabric.Point(activeObjectLeft, objectTop + objectHeight / 2 - activeObjectHeight / 2), 'center', 'center')
        }
      }
  
      if (!horizontalInTheRange) {
        horizontalLines.length = 0
      }
  
      if (!verticalInTheRange) {
        verticalLines.length = 0
      }
    })
    
    canvas.on('mouse:wheel', () => {
      verticalLines.length = horizontalLines.length = 0
    })
  
    canvas.on('before:render', function() {    
      canvas.clearContext(canvas.contextTop)
    })
  
    canvas.on('after:render', () => {
      for (let i = verticalLines.length; i--; ) {
        drawVerticalLine(verticalLines[i])
      }
      for (let i = horizontalLines.length; i--; ) {
        drawHorizontalLine(horizontalLines[i])
      }
  
      
    //   this.alignmentLines_horizontal = JSON.stringify(horizontalLines, null, 4)
    //   this.alignmentLines_vertical = JSON.stringify(verticalLines, null, 4)
      
     // console.log("activeObject left edge x is: " + canvas.getActiveObject().left)
  
      //verticalLines.length = horizontalLines.length = 0
      
      canvas.calcOffset()
    })
  
    canvas.on('mouse:up', () => {
      //verticalLines.length = horizontalLines.length = 0
      canvas.renderAll()
      //this.alignmentLines_horizontal = horizontalLines
      //this.alignmentLines_vertical = verticalLines
      //updateInfo()
    })
    
    
  
  }



export function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
}


export const getResolutionScaleValue = (width,height) => {
  debugger // eslint-disable-line no-debugger

  const parentElement = document.querySelector(".canvas-box")?.parentElement;
const ParentWidth = parentElement?.offsetWidth || 0;
const ParentHeight = parentElement?.offsetHeight || 0;

// Calculate the maximum scale value ensuring the child stays inside the canvas
const scaleX = (ParentWidth - 20) / width;
const scaleY = (ParentHeight -30) / height;

// Use the smaller scale to ensure the child fits within the canvas
const scale = Math.min(scaleX, scaleY);

return scale;
  
}